import sonnenMp4 from 'assets/videos/sonnen.mp4';
import sonnenWebm from 'assets/videos/sonnen.webm';
import hackthewindMp4 from 'assets/videos/wind-turbine.mp4';
import hackthewindWebm from 'assets/videos/wind-turbine.webm';
import takamolMp4 from 'assets/videos/takamol.mp4';
import takamolWebm from 'assets/videos/takamol.webm';

export const data = [
  {
    video: [
      { src: sonnenWebm, type: 'video/webm' },
      { src: sonnenMp4, type: 'video/mp4' },
    ],
    image: 'sonnenImg',
    intro: 'SONNEN, GERMANY',
    headline: 'Web app visualizing energy',
    description:
      'Delivering a core web product when your in&#8209;house development team is busy.',
    color: 'pigeon-post',
    tags: ['ReactJS', 'designthinking', 'lean'],
    logo: 'sonnenLogo',
    link: '/work/case-study-sonnen/',
  },
  {
    video: [
      { src: takamolWebm, type: 'video/webm' },
      { src: takamolMp4, type: 'video/mp4' },
    ],
    image: 'takamolImg',
    intro: 'TAKAMOL, SAUDI ARABIA',
    headline: 'E-commerce for the MENA market',
    description:
      'Delivering an e-commerce MVP without an in&#8209;house product team in just 6 weeks.',
    color: 'pigeon-post',
    tags: ['symfony', 'MVP', 'UX/UI'],
    logo: 'takamolLogo',
    link: '/blog/case-study-tojjar/',
  },
  {
    video: [
      { src: hackthewindWebm, type: 'video/webm' },
      { src: hackthewindMp4, type: 'video/mp4' },
    ],
    image: 'hackthewindImg',
    intro: 'HACK THE WIND',
    headline: 'Predictive maintenance software for wind turbines',
    description:
      'Developing a machine learning- based prototype in less than 48 hours.',
    color: 'pigeon-post',
    tags: ['machinelearning ', 'python', 'prototype'],
    logo: 'hackthewindLogo',
    link: '/work/case-study-predictive-maintenance/',
  },
];
